<template>
    <div class="busTraffic">
        <h2>{{$t('traffic_type['+type+']')}}</h2>
        <trafficRoute :traffic_route="n" v-for="(n,i) in busTraffic_route" :key="i"></trafficRoute>
    </div>

</template>

<script>
    import trafficRoute from './trafficRoute';

    export default {
        name: "busTraffic",
        props:['busTraffic_route','type'],
        components: {
            trafficRoute
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';
    .busTraffic {
        width: @width;
        h2 {
            line-height: 50px;
        }
    }

</style>
